import cookie from 'react-cookie';
import userLegacySettings from '../utils/user/settings';
import { getAllTreatments } from './split';
import {
  LOTUS,
  LOLA,
  BW_WEB_LOTUS_TOGGLE,
} from '../common/constants';
import { getAllowedModels } from '../common/helpers';

export const getUserDetails = (state) => {
  const userDetails = state.user.details;
  const warningType = state.user.warningType;
  const data = {
    ...userDetails,
    warningType,
  };
  if (data) {
    return data;
  }
  return null;
};

export const getUserSettings = (state) => {
  const data = state.user.settings;
  if (data) {
    return data;
  }
  return null;
};

// Return the saved user model, either in app state or cookies.
// But if for some reason it is saved as LOTUS and we have turned
// LOTUS off, make sure not to return that
export const getUserBwWindWaveModel = (state) => {
  const { settings } = state.user;
  const savedModel = settings.bwWindWaveModel || cookie.load('bw_wind_wave_model');
  const treatment = getAllTreatments(state)[BW_WEB_LOTUS_TOGGLE];
  const allowedModels = getAllowedModels(treatment);

  if (allowedModels.includes(savedModel)) {
    return savedModel;
  }

  if (allowedModels.includes(LOTUS)) {
    return LOTUS;
  }

  return LOLA;
};

export const getUserBwUnitPreference = (state) => {
  const { settings } = state.user;

  return settings.bwUnitPreference;
};

export const getUserLocation = (state) => {
  const data = state.user.location;
  if (data) {
    return data;
  }
  return null;
};

export const getUserEntitlements = (state) => {
  const data = state.user.entitlements;
  if (data) {
    return data;
  }
  return null;
};

export const getUserLegacyEntitlements = (state) => {
  const data = state.user.legacyEntitlements;
  if (data) {
    return data;
  }
  return [];
};

export const getUserFavorites = ({ user }) => (
  user.favorites.data.sort((a, b) => a.rank - b.rank)
);

export const getUserId = ({ user }) => (user.details ? user.details._id : null);

export const getUserLegacySettings = (state) => {
  const userDetails = getUserDetails(state);
  const userLocation = getUserLocation(state);
  const userSettings = getUserSettings(state);
  const userLegacyEntitlements = getUserLegacyEntitlements(state);
  const userFavorites = getUserFavorites(state);
  return userLegacySettings(
    userDetails,
    userLocation,
    userSettings,
    userLegacyEntitlements,
    userFavorites,
  );
};

export const getBasicStatus = state => state.user.entitlements.includes('bw_basic');
export const getPremiumStatus = state => state.user.entitlements.includes('bw_premium');



// WEBPACK FOOTER //
// ./src/selectors/user.js